import { api, unwrap, v4 as uuid } from '@saas-kit/lib';

import type { AcceptInviteInput } from './schemas';

function withIdempotency(): { headers: Record<string, string> } {
  return { headers: { 'Idempotency-Key': uuid() } };
}

export async function acceptInvite(
  token: string,
  input: AcceptInviteInput,
): Promise<{ user_id: string }> {
  return unwrap<{ user_id: string }>(
    api.post(`/auth/invitations/${token}/accept`, input, withIdempotency()),
  );
}
